import { v4 as uuidv4 } from 'uuid';

export function generateUuid() {
    return uuidv4().replace(/-/g, '').substring(0, 12);
}

export function closeWindow(){
    window.close();
}